import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import permissionGrantDTO, { PermissionGrantDTO } from '../../../../domain/permission/PermissionGrantDTO'
import { logMessage } from '../../../../util/Logging'
import { requireAuthContext } from '../../authorization/GlobalAuthContext'
import PermissionGrantId = com.eidu.sharedlib.entity.permission.PermissionGrantId

export type GetPermissionGrantParameters = { id: PermissionGrantId }

const getPermissionGrant = async ({ id }: GetPermissionGrantParameters): Promise<PermissionGrantDTO | null> => {
  const authContext = await requireAuthContext()
  return fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/permissions/grants/${id.toString()}`, {
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      Accept: 'application/json',
    },
  }).then(async (response) => {
    switch (response.status) {
      case 200:
        return permissionGrantDTO((await response.json()).document)
      case 404:
        logMessage(`Got status ${response.status} from getPermissionGrant endpoint`, 'warning')
        return null
      default:
        throw Error(`Unexpected response code ${response.status} from getPermissionGrant endpoint`)
    }
  })
}

export default getPermissionGrant
